import { loader } from 'graphql.macro'

export default function onlineScheduleCustomizations ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const onlineScheduleCustomizationsSchema = loader('./onlineScheduleCustomizations.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(onlineScheduleCustomizationsSchema, {
    haulerId: variables.haulerId
  })
}
